import { Link } from 'react-router-dom'
import { Mail, Chrome } from 'lucide-react'

function Footer() {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    product: [
      { name: 'Features', href: '/#features' },
      { name: 'Pricing', href: '/pricing' },
      { name: 'Chrome Extension', href: 'https://chromewebstore.google.com/detail/hireflow-linkedin-to-resu/mlpiocpnoigheicpmdolcfehlmpnhcob', external: true },
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' },
      { name: 'Refund Policy', href: '/refund' },
    ],
    support: [
      { name: 'Contact Us', href: '/contact' },
      { name: 'Email Support', href: 'mailto:hireflowapp@gmail.com' },
    ],
  }

  return (
    <footer className="bg-neutral-900 text-neutral-300">
      <div className="container-custom">
        {/* Main Footer */}
        <div className="py-12 lg:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
            {/* Brand Column */}
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-400 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-lg">H</span>
                </div>
                <span className="text-xl font-bold text-white">HireFlow</span>
              </Link>
              <p className="text-neutral-400 mb-6 max-w-sm">
                Transform your LinkedIn profile into professional resumes with AI. Land your dream job faster with job-matched resumes and ATS optimization.
              </p>
              <div className="flex items-center space-x-4">
                <a
                  href="https://chromewebstore.google.com/detail/hireflow-linkedin-to-resu/mlpiocpnoigheicpmdolcfehlmpnhcob"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 text-sm text-neutral-300 hover:text-white transition-colors"
                  aria-label="Chrome Web Store"
                >
                  <Chrome className="w-5 h-5" />
                  <span>Chrome Store</span>
                </a>
                <a
                  href="mailto:hireflowapp@gmail.com"
                  className="inline-flex items-center space-x-2 text-sm text-neutral-300 hover:text-white transition-colors"
                  aria-label="Email Support"
                >
                  <Mail className="w-5 h-5" />
                  <span>Support</span>
                </a>
              </div>
            </div>

            {/* Product Links */}
            <div>
              <h3 className="text-white font-semibold mb-4">Product</h3>
              <ul className="space-y-3">
                {footerLinks.product.map((link) => (
                  <li key={link.name}>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-neutral-400 hover:text-white transition-colors"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-neutral-400 hover:text-white transition-colors"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal Links */}
            <div>
              <h3 className="text-white font-semibold mb-4">Legal</h3>
              <ul className="space-y-3">
                {footerLinks.legal.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-neutral-400 hover:text-white transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support Links */}
            <div>
              <h3 className="text-white font-semibold mb-4">Support</h3>
              <ul className="space-y-3">
                {footerLinks.support.map((link) => (
                  <li key={link.name}>
                    {link.href.startsWith('mailto:') ? (
                      <a
                        href={link.href}
                        className="text-sm text-neutral-400 hover:text-white transition-colors"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-neutral-400 hover:text-white transition-colors"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
            <p className="text-sm text-neutral-400">
              &copy; {currentYear} HireFlow. All rights reserved.
            </p>
            <p className="text-sm text-neutral-400">
              Made with passion for job seekers worldwide
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
